import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import MessageType from '../../../enums/MessageType';
import Message from '../../../v2/components/ui/Message/Message';
import Translation from '../../../v2/lang/Translation';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  deliveryOptionDelayMessage: {
    marginBottom: Spacing.double,
  },
});

export function DeliveryOptionDelayMessage(props) {
  const classes = useStyles();
  if (!props.delayMessage) return null;
  return (
    <div className={classes.deliveryOptionDelayMessage} data-test="DeliveryOptionDelayMessage">
      <Message type={MessageType.INFO}>
        <Translation>{props.delayMessage}</Translation>
      </Message>
    </div>
  );
}

DeliveryOptionDelayMessage.defaultProps = {
  delayMessage: '',
};

DeliveryOptionDelayMessage.propTypes = {
  delayMessage: PropTypes.string,
};

const mapStateToProps = state => ({
  // todo - Decouple delay message from Nintento in start settings
  delayMessage: state.start.settings.nintendo_delay_message,
});

export default connect(mapStateToProps)(DeliveryOptionDelayMessage);
